'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _common = require('./common');

var _batchedAdd = require('../batchedAdd');

var _batchedAdd2 = _interopRequireDefault(_batchedAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextBufferId = 0;

var BufferState = function () {
    function BufferState(name, networkid, state, messageDict) {
        (0, _classCallCheck3.default)(this, BufferState);

        this.id = nextBufferId++;
        this.networkid = networkid;
        this.name = name;
        this.topics = [];
        this.key = '';
        this.joined = false;
        this.enabled = true;
        this.created_at = null;
        this.users = (0, _create2.default)(null);
        this.modes = (0, _create2.default)(null);
        this.flags = {
            unread: 0,
            alert_on: 'default',
            has_opened: false,
            channel_badkey: false,
            chathistory_available: true,
            requested_modes: false,
            requested_banlist: false,
            is_requesting_chathistory: false
        };
        this.settings = {};
        this.last_read = 0;
        this.active_timeout = null;
        this.message_count = 0;
        this.current_input = '';
        this.input_history = [];
        this.input_history_pos = 0;
        this.show_input = true;

        this.chathistory_request_count = 0;

        _vue2.default.observable(this);

        (0, _common.def)(this, 'state', state, false);
        (0, _common.def)(this, 'messageDict', messageDict, false);

        var messagesObj = {
            networkid: this.networkid,
            buffer: this.name,
            messages: [],
            messageIds: (0, _create2.default)(null)
        };
        this.messageDict.push(messagesObj);
        (0, _common.def)(this, 'messagesObj', messagesObj, false);

        (0, _common.def)(this, 'addMessageBatch', createMessageBatch(this), false);
        (0, _common.def)(this, 'addUserBatch', createUserBatch(this), false);

        if (this.isChannel()) {
            maybeStartWhoLoop(this);
        }

        function onNetworkConnecting(event) {
            if (event.network === this.getNetwork()) {
                this.chathistory_request_count = 0;
            }
        }

        function onNetworkMotd(event, network) {
            if (network === this.getNetwork() && this.isQuery()) {
                this.requestLatestScrollback();
            }
        }

        function onBufferClose(event) {
            if (event.buffer === this) {
                this.state.$off('network.connecting', onNetworkConnectingBound);
                this.state.$off('buffer.close', onBufferCloseBound);
            }
        }

        var onNetworkConnectingBound = onNetworkConnecting.bind(this);
        var onBufferCloseBound = onBufferClose.bind(this);
        var onNetworkMotdBound = onNetworkMotd.bind(this);

        state.$on('network.connecting', onNetworkConnectingBound);
        state.$on('buffer.close', onBufferCloseBound);
        state.$on('irc.motd', onNetworkMotdBound);

        if (this.isQuery() && this.getNetwork().ircClient.chathistory.isSupported()) {
            this.requestLatestScrollback();
        }
    }

    (0, _createClass3.default)(BufferState, [{
        key: 'getNetwork',
        value: function getNetwork() {
            return this.state.getNetwork(this.networkid);
        }
    }, {
        key: 'getMessages',
        value: function getMessages() {
            var bufMessages = _lodash2.default.find(this.messageDict, {
                networkid: this.networkid,
                buffer: this.name
            });

            return bufMessages ? bufMessages.messages : [];
        }
    }, {
        key: 'clearMessages',
        value: function clearMessages() {
            this.messagesObj.messages.splice(0, this.messagesObj.messages.length);
            this.messagesObj.messageIds = (0, _create2.default)(null);
        }
    }, {
        key: 'isServer',
        value: function isServer() {
            return this.name === '*';
        }
    }, {
        key: 'isChannel',
        value: function isChannel() {
            var chanPrefixes = ['#', '&'];
            var ircNetwork = this.getNetwork().ircClient.network;
            if (ircNetwork && ircNetwork.options.CHANTYPES) {
                chanPrefixes = ircNetwork.options.CHANTYPES;
            }

            return chanPrefixes.indexOf(this.name[0]) > -1;
        }
    }, {
        key: 'isQuery',
        value: function isQuery() {
            var chanPrefixes = ['#', '&'];
            var ircNetwork = this.getNetwork().ircClient.network;
            if (ircNetwork && ircNetwork.options.CHANTYPES) {
                chanPrefixes = ircNetwork.options.CHANTYPES;
            }

            return chanPrefixes.indexOf(this.name[0]) === -1 && !this.isSpecial() && !this.isServer();
        }
    }, {
        key: 'isSpecial',
        value: function isSpecial() {
            var name = this.name;
            return name[0] === '*' && name.length > 1;
        }
    }, {
        key: 'isUserAnOp',
        value: function isUserAnOp(nick) {
            var user = this.state.getUser(this.networkid, nick);
            if (!user) {
                return false;
            }

            var userBufferInfo = user.buffers[this.id];
            if (!userBufferInfo) {
                return false;
            }

            var modes = userBufferInfo.modes;
            var opModes = ['Y', 'y', 'q', 'a', 'o', 'h'];
            var hasOp = _lodash2.default.find(modes, function (mode) {
                return opModes.indexOf(mode.toLowerCase()) > -1;
            });

            return !!hasOp;
        }
    }, {
        key: 'userModePrefix',
        value: function userModePrefix(user) {
            if (!user.buffers[this.id]) {
                return '';
            }

            var modes = user.buffers[this.id].modes;
            if (modes.length === 0) {
                return '';
            }

            var network = this.getNetwork();
            var netPrefixes = network.ircClient.network.options.PREFIX;

            var prefix = _lodash2.default.find(netPrefixes, function (p) {
                return modes.indexOf(p.mode) > -1;
            });

            return prefix ? prefix.symbol : '';
        }
    }, {
        key: 'userMode',
        value: function userMode(user) {
            if (!user.buffers[this.id]) {
                return '';
            }

            var modes = user.buffers[this.id].modes;
            if (modes.length === 0) {
                return '';
            }

            if (modes.length === 1) {
                return modes[0];
            }

            var network = this.getNetwork();
            var netPrefixes = network.ircClient.network.options.PREFIX;

            var prefix = _lodash2.default.find(netPrefixes, function (p) {
                return modes.indexOf(p.mode) > -1;
            });

            return prefix ? prefix.mode : '';
        }
    }, {
        key: 'setting',
        value: function setting(name, val) {
            if (typeof val !== 'undefined') {
                this.state.$set(this.settings, name, val);
                return val;
            }

            var result = typeof this.settings[name] !== 'undefined' ? this.settings[name] : this.state.setting('buffers.' + name);

            return result;
        }
    }, {
        key: 'rename',
        value: function rename(newName) {
            var network = this.getNetwork();
            var oldName = this.name;
            var setActive = this.state.getActiveBuffer() === this;

            this.name = newName;
            if (setActive) {
                this.state.setActiveBuffer(network.id, newName);
            }

            var bufferMessages = _lodash2.default.find(this.messageDict, { networkid: network.id, buffer: oldName });
            bufferMessages.buffer = newName;
        }
    }, {
        key: 'flag',
        value: function flag(name, val) {
            if (typeof val !== 'undefined') {
                this.state.$set(this.flags, name, val);
                return val;
            }

            return this.flags[name];
        }
    }, {
        key: 'requestScrollback',
        value: function requestScrollback(_direction) {
            var _this = this;

            var direction = _direction || 'backward';
            var time = '';
            var chathistoryFuncName = 'before';

            if (direction === 'backward') {
                var lastMessage = this.getMessages().reduce(function (earliest, current) {
                    var ignoreTypes = ['traffic', 'topic', 'connection', 'presence'];
                    var validType = ignoreTypes.indexOf(earliest.type) === -1;
                    if (validType && earliest.time && earliest.time < current.time) {
                        return earliest;
                    }
                    return current;
                }, this.getMessages()[0]);

                chathistoryFuncName = 'before';
                time = lastMessage ? new Date(lastMessage.server_time) : new Date();
            } else if (direction === 'forward') {
                var firstMessage = this.getMessages().reduce(function (latest, current) {
                    var ignoreTypes = ['traffic', 'topic', 'connection', 'presence'];
                    var validType = ignoreTypes.indexOf(latest.type) === -1;
                    if (validType && latest.time && latest.time > current.time) {
                        return latest;
                    }
                    return current;
                }, this.getMessages()[0]);

                chathistoryFuncName = 'after';
                time = firstMessage ? new Date(firstMessage.server_time) : new Date();
            } else {
                throw new Error('Invalid direction for requestScrollback(): ' + _direction);
            }

            var ircClient = this.getNetwork().ircClient;
            this.flag('is_requesting_chathistory', true);
            this.chathistory_request_count += 1;
            ircClient.chathistory[chathistoryFuncName](this.name, time).then(function (event) {
                if (!event) {
                    _this.flag('chathistory_available', false);
                    return;
                }

                var hasNewMessages = event.commands.some(function (msg) {
                    return msg.tags.msgid && !_this.messagesObj.messageIds[msg.tags.msgid];
                });

                _this.flag('chathistory_available', hasNewMessages);
            }).finally(function () {
                _this.flag('is_requesting_chathistory', false);
            });
        }
    }, {
        key: 'requestLatestScrollback',
        value: function requestLatestScrollback() {
            var _this2 = this;

            var ircClient = this.getNetwork().ircClient;
            this.flag('is_requesting_chathistory', true);
            this.chathistory_request_count += 1;
            ircClient.chathistory.before(this.name, '*').finally(function () {
                _this2.flag('is_requesting_chathistory', false);
            });
        }
    }, {
        key: 'markAsRead',
        value: function markAsRead(delayed) {
            if (this.active_timeout) {
                clearTimeout(this.active_timeout);
                this.active_timeout = null;
            }
            if (delayed) {
                this.active_timeout = setTimeout(this.markAsRead.bind(this), 10000, false);
            } else {
                this.last_read = Date.now();
                this.flag('highlight', false);

                var network = this.getNetwork();
                var allowedUpdate = !network ? false : this.isChannel() || this.isQuery();
                if (allowedUpdate && network.connection.bncbncnetidname) {
                    network.ircClient.bnc.bufferSeen(network.connection.bncnetid, this.name, new Date());
                }
            }
        }
    }, {
        key: 'incrementFlag',
        value: function incrementFlag(flagName) {
            this.flags[flagName] = (this.flags[flagName] || 0) + 1;
        }
    }, {
        key: 'addUser',
        value: function addUser(user) {
            this.addUserBatch(user);
        }
    }, {
        key: 'removeUser',
        value: function removeUser(nick) {
            var userObj = this.state.getUser(this.networkid, nick);

            _lodash2.default.pull(this.addUserBatch.queue(), userObj);

            this.state.$delete(this.users, nick.toLowerCase());

            if (userObj) {
                delete userObj.buffers[this.id];
            }
        }
    }, {
        key: 'clearUsers',
        value: function clearUsers() {
            var _this3 = this;

            this.addUserBatch && this.addUserBatch.queue().splice(0);

            _lodash2.default.each(this.users, function (userObj, nick) {
                delete userObj.buffers[_this3.id];
            });

            this.state.$set(this, 'users', {});
        }
    }, {
        key: 'addMessage',
        value: function addMessage(message) {
            this.addMessageBatch(message);
        }
    }, {
        key: 'say',
        value: function say(message) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var network = this.getNetwork();
            var newMessage = {
                time: Date.now(),
                nick: network.nick,
                message: message,
                type: opts.type || 'privmsg'
            };

            this.state.addMessage(this, newMessage);

            var fnNames = {
                privmsg: 'say',
                action: 'action',
                notice: 'notice'
            };
            var fnName = fnNames[opts.type] || 'say';
            network.ircClient[fnName](this.name, message);
        }
    }, {
        key: 'join',
        value: function join() {
            if (!this.isChannel()) {
                return;
            }

            var network = this.getNetwork();
            network.ircClient.join(this.name, this.key || '');
        }
    }, {
        key: 'part',
        value: function part(reason) {
            if (!this.isChannel()) {
                return;
            }

            var network = this.getNetwork();
            network.ircClient.part(this.name, reason || '');
        }
    }, {
        key: 'scrollToMessage',
        value: function scrollToMessage(id) {
            this.state.$emit('messagelist.scrollto', { id: id });
        }
    }, {
        key: 'getLoadingState',
        value: function getLoadingState() {
            var networkState = this.getNetwork().state;
            var historySupport = !!this.getNetwork().ircClient.chathistory.isSupported();
            var messagesInBatchQueue = this.addMessageBatch.queue().length;

            var messageCount = this.message_count;

            if (networkState === 'disconnected') {
                return 'disconnected';
            } else if (networkState === 'connecting') {
                return 'connecting';
            } else if (networkState === 'connected' && this.joined && this.enabled && historySupport && (this.flags.is_requesting_chathistory || this.chathistory_request_count === 0 || messagesInBatchQueue > 0)) {
                return 'loading';
            }
            return 'done';
        }
    }, {
        key: 'isReady',
        value: function isReady() {
            return this.getLoadingState() === 'done';
        }
    }, {
        key: 'topic',
        get: function get() {
            return this.topics.length === 0 ? '' : this.topics[this.topics.length - 1];
        },
        set: function set(newVal) {
            this.topics.push(newVal);
        }
    }]);
    return BufferState;
}();

exports.default = BufferState;

function createUserBatch(bufferState) {
    var addSingleUser = function addSingleUser(u) {
        bufferState.state.$set(bufferState.users, u.nick.toLowerCase(), u);
    };
    var addMultipleUsers = function addMultipleUsers(users) {
        var o = _lodash2.default.clone(bufferState.users);
        users.forEach(function (u) {
            o[u.nick.toLowerCase()] = u;
        });
        bufferState.users = o;
    };

    return (0, _batchedAdd2.default)(addSingleUser, addMultipleUsers);
}

function createMessageBatch(bufferState) {
    var addSingleMessage = function addSingleMessage(newMessage) {
        if (bufferState.messagesObj.messageIds[newMessage.id]) {
            return;
        }
        bufferState.messagesObj.messages.push(newMessage);
        bufferState.messagesObj.messageIds[newMessage.id] = newMessage;
        trimMessages();
        bufferState.message_count++;
    };
    var addMultipleMessages = function addMultipleMessages(newMessages) {
        var toAdd = newMessages.filter(function (msg) {
            return !bufferState.messagesObj.messageIds[msg.id];
        });
        if (toAdd.length > 0) {
            bufferState.messagesObj.messages = bufferState.messagesObj.messages.concat(toAdd);
            toAdd.forEach(function (msg) {
                bufferState.messagesObj.messageIds[msg.id] = msg;
            });
            trimMessages();
        }

        bufferState.message_count++;
    };
    var trimMessages = function trimMessages() {
        var scrollbackSize = bufferState.setting('scrollback_size');
        var length = bufferState.messagesObj.messages.length;

        if (bufferState.messagesObj.messages.length > scrollbackSize) {
            var removed = bufferState.messagesObj.messages.splice(0, length - scrollbackSize);
            removed.forEach(function (msg) {
                return delete bufferState.messagesObj.messageIds[msg.id];
            });
        }
    };

    return (0, _batchedAdd2.default)(addSingleMessage, addMultipleMessages);
}

function maybeStartWhoLoop(bufferState) {
    var network = bufferState.state.getNetwork(bufferState.networkid);

    if (network.state === 'connected') {
        nextLoop();
    } else {
        var on001 = function on001(command, event, eventNetwork) {
            if (eventNetwork === network) {
                bufferState.state.$off('irc.raw.001', on001);
                nextLoop();
            }
        };
        bufferState.state.$on('irc.raw.001', on001);
    }

    function nextLoop() {
        setTimeout(updateWhoStatusLoop, 30000);
    }

    function updateWhoStatusLoop() {
        network = bufferState.state.getNetwork(bufferState.networkid);

        if (!network) {
            return;
        }

        if (!network.bufferByName(bufferState.name)) {
            return;
        }

        var whoLoop = bufferState.setting('who_loop');
        var isJoined = bufferState.joined;
        var hasAwayNotify = network.ircClient.network.cap.isEnabled('away-notify');
        var networkConnected = network.state === 'connected';

        if (whoLoop && networkConnected && isJoined && !hasAwayNotify) {
            network.ircClient.who(bufferState.name, function () {
                nextLoop();
            });
        } else {
            nextLoop();
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/libs/state/BufferState.js
// module id = FKBE
// module chunks = 1